<main class="detail" id="billing">
    <header>
        <header-component></header-component>
        <div class="nav">
            <h1>
                {{ isCancellationFee ? _('cancellation_fee_payment') :
                (app.checkedin ? _('online_payment') : _('prepayment'))}}
            </h1>
            <span
                class="icon back"
                @click="app.setPage('BillingBreakdown')"
                v-if="!isCancellationFee"
            >
                chevron_left
            </span>
        </div>
    </header>
    <section class="navigation">
        <Pointer :total="3" :current="page"></Pointer>
        <h3 v-if="page == 1">{{_('please_input_card_number')}}</h3>
        <h3 v-if="page == 2">{{_('please_check_payment')}}</h3>
        <h3 v-if="page == 3">{{_('payment_success')}}</h3>
    </section>
    <hr />

    <template v-if="page == 1">
        <section>
            <h4>
                {{isCancellationFee ? _('cancellation_fee') :
                _('billing_amount')}}
            </h4>
            <p>{{ unpaidAmount() | price }}</p>
        </section>
        <hr />
        <section>
            <h4>{{_('card_number')}} *</h4>
            <label class="wrap-input">
                <span ref="card"></span>
            </label>
        </section>
        <hr />
        <section>
            <h4>{{_('expiry_date')}} *</h4>
            <label class="wrap-input select">
                <span ref="expiry"></span>
            </label>
        </section>
        <hr />
        <section>
            <h4>{{_('cvc')}} *</h4>
            <label class="wrap-input">
                <span ref="cvc"></span>
            </label>
        </section>
        <hr />

        <section class="buttons">
            <button @click="createToken()">{{_('go_next')}}</button>
        </section>
    </template>

    <template v-if="page == 2">
        <section
            class="breakdown"
            v-if="breakdown.length && !isCancellationFee"
        >
            <h4>{{_('billing_breakdown')}}</h4>
            <div class="d_flex" v-for="bill in breakdown">
                <p>{{bill.item_name}}</p>
                <p>{{bill.amount | price }}</p>
            </div>
        </section>
        <hr v-if="breakdown.length && !isCancellationFee" />
        <section>
            <h4>{{_('payment_amount')}}</h4>
            <p class="red">{{unpaidAmount() | price }}</p>
        </section>
        <hr />

        <template v-if="token && token.card">
            <section>
                <h4>{{_('card_number')}}</h4>
                <p>**** ***** ***** {{token.card.last4}}</p>
            </section>
            <hr />
            <section>
                <h4>{{_('expiry_date')}}</h4>
                <p>{{token.card.exp_month}} / {{token.card.exp_year}}</p>
            </section>
            <hr />
            <section>
                <h4>{{_('cvc')}}</h4>
                <p>***</p>
            </section>
            <hr />
        </template>

        <section v-if="token" class="flex-buttons">
            <button class="skeleton" @click="toCardInput()">
                {{_('go_back')}}
            </button>
            <button @click="payment()">{{_('make_payment')}}</button>
        </section>
    </template>

    <template v-if="page == 3">
        <section v-if="isCancellationFee">
            <h4>{{_('cancellation_fee_payment_complete')}}</h4>
            <p>{{_('cancellation_fee_payment_complete_message')}}</p>
        </section>
        <section v-else>
            <h4>{{_('payment_history')}}</h4>
            <table>
                <tr v-for="ch in charges">
                    <th before-icon="credit_card">{{ch.created}}</th>
                    <td class="price">{{ch.amount | price }}</td>
                </tr>
            </table>
        </section>
        <hr />
        <section class="remarks" v-if="!isCancellationFee">
            <pre>※ {{_('payment_history_remark')}}</pre>
        </section>
        <hr v-if="!isCancellationFee" />

        <section class="flex-buttons" v-if="isCancellationFee">
            <button @click="app.setPage('IssueReceipt')">
                {{_('receipt_issuance')}}
            </button>
        </section>
        <section class="flex-buttons" v-else>
            <button class="skeleton" @click="app.setPage('Terminal')">
                {{_('go_back')}}
            </button>
        </section>
    </template>

    <hr />
    <section class="remarks">
        <pre>※ {{_('request_payment_text')}}</pre>
        <a href="https://stripe.com/" target="_blank"
            ><p>https://stripe.com/</p></a
        >
    </section>
    <hr />
    <tab-bar v-if="!isCancellationFee" :page="app.query.page"></tab-bar>
</main>
